import { useState, useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import get from 'lodash/get';
import isObject from 'lodash/isObject';

import { AssistantBackBar } from '../../components/assistant';
import useChatbotCommandRunner from '../../common/use-chatbot-command-runner';
import { trackAssistantDialogLoad } from '../../models/assistant/analytics';
import styles from './assistant.module.scss';
import ChatbotCommandResult from '../../components/assistant/chatbot-command-result';

/**
 * Chatbot-specific command runner that replaces AssistantHistory when chatbot is enabled.
 * Key differences from AssistantHistory:
 * - For internal navigation: uses replace() to avoid adding to history stack
 * - For request commands: shows only the last result without chat history
 * - Does not display the user's command text
 */
const AssistantChatbotCommandRunner = ({
  location,
  history,
}: RouteComponentProps) => {
  const [showGoBack, setShowGoBack] = useState(false);
  const { runCommand, lastResult, isLoading } = useChatbotCommandRunner();

  useEffect(() => {
    if (isObject(location.state)) {
      const command = get(location.state, 'command');

      setShowGoBack(Boolean(command || get(location.state, 'showBack')));

      if (command) {
        // Use replace to update state without adding another history entry
        history.replace({
          pathname: location.pathname,
          state: { showBack: true },
        });
        runCommand(command, get(location.state, 'analyticsData'));
        setShowGoBack(true);
        trackAssistantDialogLoad({
          location: 'deeplink',
        });
      }
    } else if (!location.state) {
      trackAssistantDialogLoad();
    }
  }, [location.state, location.pathname, history, runCommand]);

  return (
    <div className="assistant__commands assistant__search-view">
      <div className={styles.body}>
        {showGoBack ? <AssistantBackBar /> : null}
        <ChatbotCommandResult result={lastResult} isLoading={isLoading} />
      </div>
    </div>
  );
};

export default AssistantChatbotCommandRunner;
